module.exports = __webpack_public_path__ + "static/media/money.50283693.jpg";